module.exports = __webpack_public_path__ + "staticcomp/img/top.0f667be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/6/top.jpg
// module id = IhjF
// module chunks = 39